const host = 'https://testrate.coffeemania.io';

function GetHost()
{
    return(host);
}

export default GetHost;